// extracted by css-extract-rspack-plugin
export default {"stickyLineObserver":"StickyLineObserverOverlay-module__stickyLineObserver__rhc2u"};